import React from "react";
import { NavLink } from "react-router-dom";

const MembershipPolicy = () => {
  const tiers = [
    {
      name: "Silver",
      emoji: "🥈",
      spend: "AED 1 – 10,000 / month",
      bg: "linear-gradient(135deg, #6B6B6B, #8A8A8A)",
      titleColor: "#F0F0F0",
      badgeBg: "#5A5A5A",
      welcome: "500 Points",
      rewards: "1,000 Points / AED 10,000",
      credit: "Up to 30 Days",
    },
    {
      name: "Gold",
      emoji: "🥇",
      spend: "AED 10,001 – 29,999 / month",
      bg: "linear-gradient(to bottom left, #FFFDE8 0%, #F6DD7A 28%, #D4AF37 62%, #9E7C0C 100%)",
      titleColor: "#000000",
      badgeBg: "linear-gradient(135deg, #C9A227, #9E7C0C)",
      welcome: "1,000 Points",
      rewards: "1,500 Points / AED 10,000",
      credit: "Up to 45 Days",
      highlight: true,
    },
    {
      name: "Platinum",
      emoji: "💎",
      spend: "AED 30,000+ / month",
      bg: "linear-gradient(135deg, #000000, #1C1C1C)",
      titleColor: "#FFFFFF",
      badgeBg: "#2B2B2B",
      welcome: "3,000 Points",
      rewards: "2,000 Points / AED 10,000",
      credit: "Up to 60 Days",
    },
  ];

  return (
    <div className="container">
      <div style={styles.container}>
        <h1 style={styles.heading}>
          Customer Membership & Reward Policy
        </h1>

        <div style={styles.grid} className="membership-grid">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              style={{
                ...styles.card,
                background: tier.bg,
                boxShadow: tier.highlight
                  ? "0 15px 35px rgba(0,0,0,0.45)"
                  : "0 10px 25px rgba(0,0,0,0.35)",
              }}
              className="membership-card"
            >
              <h2 style={{ ...styles.title, color: tier.titleColor }}>
                {tier.name}
              </h2>

              <div
                style={{
                  ...styles.badge,
                  background: tier.badgeBg,
                }}
              >
                {tier.spend}
              </div>

              <ul style={styles.list}>
                <li style={{ fontSize: "16px" }}>
                  🎁 Welcoming Bonus: <b>{tier.welcome}</b>
                </li>
                <li style={{ fontSize: "14px" }}>
                  ⭐ Rewards: <b>{tier.rewards}</b>
                </li>
                <li style={{ fontSize: "16px" }}>
                  ⏳ Credit Facility: <b>{tier.credit}</b>
                </li>
              </ul>
            </div>
          ))}
        </div>

        <NavLink to="/MyAccount/RedeemPoints" style={styles.link}>
          View Redeem Offers
        </NavLink>
      </div>

      {/* ================= RESPONSIVE CSS ================= */}
      <style>
        {`
        @media (max-width: 992px) {
          .membership-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 768px) {
          .membership-grid {
            grid-template-columns: 1fr !important;
          }

          .membership-card {
            max-width: 100% !important;
            margin: 0 auto 20px auto;
          }

          h1 {
            font-size: 1.6rem !important;
          }
        }
        `}
      </style>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "40px 20px",
    textAlign: "center",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },

  heading: {
    fontSize: "2.4rem",
    fontWeight: "700",
    marginBottom: "35px",
    color: "#111",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    justifyContent: "center",
    margin: "0 auto",
    maxWidth: "1000px",
    gap: "20px",
  },

  card: {
    borderRadius: "20px",
    padding: "30px 22px",
    minHeight: "340px",
    maxWidth: "300px",
    color: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "transform 0.3s ease",
  },

  title: {
    fontSize: "3rem",
    fontWeight: "700",
    marginBottom: "14px",
  },

  badge: {
    padding: "7px 18px",
    borderRadius: "22px",
    fontSize: "0.85rem",
    fontWeight: "600",
    color: "#fff",
  },

  list: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    marginTop: "50px",
    width: "100%",
    textAlign: "left",
    lineHeight: "1.9",
    fontSize: "0.95rem",
  },

  link: {
    marginTop: "35px",
    display: "inline-block",
    fontSize: "1rem",
    fontWeight: "600",
    textDecoration: "none",
    color: "#007bff",
  },
};

export default MembershipPolicy;
